import { EMPTY_OBJECT } from '../../constants/common'
import { getPostProfilePathname } from '../../utils/link'

import { POST_LIST_API_PAGE_SIZE, POST_TYPE_TICKER } from './Post.constants'

export function isPostTypeTicker(type) {
  return type === POST_TYPE_TICKER
}

export function getPostListItemsData({ data }) {
  return data.items
}

export function getNextFilterParamsFromPostListItems(items, filterValues) {
  return {
    filters: {
      ...(items.length > 1
        ? { from_uuid: items[items.length - 1].uuid }
        : EMPTY_OBJECT),
      ...filterValues,
    },
  }
}

export function checkPostListIsLastPage(response) {
  return getPostListItemsData(response).length < POST_LIST_API_PAGE_SIZE
}

export function toPostMessageTemplateSelectItem(template) {
  return {
    label: template.name,
    value: template.id,
  }
}

export function toPostMessageTemplateSelectItems(items) {
  return items.map(toPostMessageTemplateSelectItem)
}

export function getPostCreationSuccessNotification({
  availableSections,
  t,
  title,
  uuid,
}) {
  return {
    linkProps: {
      reloadDocument: true,
      title: t('Notification.PostCreatedViewLinkKey'),
      to: getPostProfilePathname({ availableSections, id: uuid }),
    },
    text: t('Newsboard.CreatePostTextNotificationKey', { title }),
    title: t('Newsboard.CreatePostNotificationTitleKey'),
  }
}
